import { render, staticRenderFns } from "./inReview.vue?vue&type=template&id=4ac55ce4&scoped=true"
import script from "./inReview.vue?vue&type=script&lang=js"
export * from "./inReview.vue?vue&type=script&lang=js"
import style0 from "./inReview.vue?vue&type=style&index=0&id=4ac55ce4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac55ce4",
  null
  
)

export default component.exports